"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiAutoComplete = getMuiAutoComplete;
function getMuiAutoComplete(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '&.Mui-focused': {
          '.MuiInputLabel-root': {
            fontSize: '14px'
          },
          borderColor: palette.primary.main
        },
        '&:hover': {
          '.MuiInputLabel-root': {
            '&.Mui-disabled': {
              color: palette.grey[300]
            },
            color: palette.common.black
          }
        },
        '.MuiFormControl-root': {
          '&.MuiTextField-root .MuiOutlinedInput-root': {
            marginTop: 0
          },
          '&.MuiTextField-root fieldset': {
            top: 0
          },
          '&.MuiTextField-root label + .MuiOutlinedInput-root': {
            marginTop: '10px'
          },
          '.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            transform: 'translate(16px, 19px) scale(1)'
          }
        },
        '.MuiInputLabel-root': {
          marginLeft: '-6px !important'
        },
        '.MuiOutlinedInput-root': {
          '&.Mui-disabled': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: palette.grey[300]
            }
          },
          '.MuiAutocomplete-input': {
            padding: '18px 16px 19px'
          },
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: palette.grey.A700
          },
          padding: 0
        }
      }
    }
  };
}